import { render } from "./InternalOrderCancerDemographicBaseline.vue?vue&type=template&id=7c1d7644&scoped=true"
import script from "./InternalOrderCancerDemographicBaseline.vue?vue&type=script&lang=js"
export * from "./InternalOrderCancerDemographicBaseline.vue?vue&type=script&lang=js"

import "./InternalOrderCancerDemographicBaseline.vue?vue&type=style&index=0&id=7c1d7644&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1d7644"]])

export default __exports__